export default "__VITE_ASSET__2b60c1a9__"